/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { dataExportsCreateDestination } from "../funcs/dataExportsCreateDestination.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Destination } from "../models/components/destination.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateDataExportDestinationRequest,
  CreateDataExportDestinationSecurity,
} from "../models/operations/createdataexportdestination.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreateDataExportDestinationMutationVariables = {
  request: CreateDataExportDestinationRequest;
  security?: CreateDataExportDestinationSecurity | undefined;
  options?: RequestOptions;
};

export type CreateDataExportDestinationMutationData = Destination;

export type CreateDataExportDestinationMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createDestination dataExports
 *
 * @remarks
 * Create a data export destination in the selected project.
 */
export function useCreateDataExportDestinationMutation(
  options?: MutationHookOptions<
    CreateDataExportDestinationMutationData,
    CreateDataExportDestinationMutationError,
    CreateDataExportDestinationMutationVariables
  >,
): UseMutationResult<
  CreateDataExportDestinationMutationData,
  CreateDataExportDestinationMutationError,
  CreateDataExportDestinationMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreateDataExportDestinationMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreateDataExportDestination(): MutationKey {
  return ["@gram/client", "dataExports", "createDestination"];
}

export function buildCreateDataExportDestinationMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreateDataExportDestinationMutationVariables,
  ) => Promise<CreateDataExportDestinationMutationData>;
} {
  return {
    mutationKey: mutationKeyCreateDataExportDestination(),
    mutationFn: function createDataExportDestinationMutationFn({
      request,
      security,
      options,
    }): Promise<CreateDataExportDestinationMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(dataExportsCreateDestination(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
